export const MY529_PLAN_ID = '1097'
export const NC529_PLAN_ID = '1072'
